export enum ScoreResetView {
  GLOBAL = 'global',
  USER = 'user'
}
